/* src/app/shared/layout/site-header/site-header.component.scss */
.account-bar {
  top: 0;
  height: 30px;
  padding-right: 50px;
  background-color: #222222;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-content: center;
  position: relative;
}
.account-bar.session-expiring {
  border-bottom: 2px solid #ff9800;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.6);
  animation: borderPulse 2s ease-in-out infinite;
}
.account-bar.api-disconnected {
  border-bottom: 2px solid #f44336;
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.6);
  animation: borderPulseRed 2s ease-in-out infinite;
}
.account-bar .account-bar-content {
  padding: 5px 10px;
  color: #ceecff;
  text-decoration: none;
  font-size: 10pt;
}
.account-bar .account-bar-content:hover {
  color: #fff;
  text-decoration: underline;
  font-weight: bold;
}
.account-bar .session-warning-container {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 20px;
  color: #ffb84d;
  font-size: 11pt;
  font-weight: 600;
  animation: textPulse 2s ease-in-out infinite;
}
.account-bar .session-warning-container i {
  color: #ff9800;
  animation: iconPulse 1s ease-in-out infinite;
}
.account-bar .session-warning-container .session-warning-text {
  white-space: nowrap;
}
.account-bar .session-warning-container.api-warning {
  color: #ff6b6b;
}
.account-bar .session-warning-container.api-warning i {
  color: #f44336;
}
@keyframes borderPulse {
  0%, 100% {
    border-bottom-color: #ff9800;
    box-shadow: 0 2px 8px rgba(255, 152, 0, 0.6);
  }
  50% {
    border-bottom-color: #ffb84d;
    box-shadow: 0 2px 12px rgba(255, 152, 0, 0.9);
  }
}
@keyframes borderPulseRed {
  0%, 100% {
    border-bottom-color: #f44336;
    box-shadow: 0 2px 8px rgba(244, 67, 54, 0.6);
  }
  50% {
    border-bottom-color: #ff6b6b;
    box-shadow: 0 2px 12px rgba(244, 67, 54, 0.9);
  }
}
@keyframes textPulse {
  0%, 100% {
    opacity: 0.95;
  }
  50% {
    opacity: 1;
  }
}
@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
}
.header-bar {
  height: 100px;
  padding-left: 50px;
  padding-right: 50px;
  background-color: #3d3c37;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom-style: solid;
  border-bottom-width: 5px;
  border-bottom-color: #82baff;
}
@media (max-width: 2560px) {
  .header-bar {
    padding-left: 42px;
    padding-right: 42px;
  }
}
@media (max-width: 1920px) {
  .header-bar {
    padding-left: 38px;
    padding-right: 38px;
  }
}
@media (max-width: 1280px) {
  .header-bar {
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media (max-width: 1024px) {
  .header-bar {
    padding-left: 10px;
    padding-right: 10px;
  }
}
.header-bar .header-bar-content {
  display: flex;
  align-items: center;
  width: 100%;
}
.header-bar .header-bar-content .logo-content {
  display: flex;
  align-items: center;
}
.header-bar .header-bar-content .logo-content .marsh-logo {
  height: 45px;
  margin-right: 40px;
}
@media (max-width: 2560px) {
  .header-bar .header-bar-content .logo-content .marsh-logo {
    height: 38px;
  }
}
@media (max-width: 1920px) {
  .header-bar .header-bar-content .logo-content .marsh-logo {
    height: 32px;
  }
}
.header-bar .header-bar-content .logo-content .app-name {
  margin-bottom: 0px;
  font-family: "Noto Sans", sans-serif;
  font-size: 1.4rem;
  font-weight: bold;
  color: #ceecff;
  letter-spacing: 0.05em;
}
@media (max-width: 2560px) {
  .header-bar .header-bar-content .logo-content .app-name {
    font-size: 1.4rem;
  }
}
@media (max-width: 1920px) {
  .header-bar .header-bar-content .logo-content .app-name {
    font-size: 1.2rem;
  }
}
@media (max-width: 1280px) {
  .header-bar .header-bar-content .logo-content .app-name {
    font-size: 1.1rem;
  }
}
@media (max-width: 1080px) {
  .header-bar .header-bar-content .logo-content .app-name {
    font-size: 1rem;
  }
}
.header-bar .header-bar-content .menu-content {
  flex: 1;
  display: flex;
  justify-content: left;
  border-radius: 10px;
  padding-left: 100px;
}
@media (max-width: 2560px) {
  .header-bar .header-bar-content .menu-content {
    padding-left: 50px;
  }
}
@media (max-width: 1920px) {
  .header-bar .header-bar-content .menu-content {
    padding-left: 20px;
  }
}
@media (max-width: 1280px) {
  .header-bar .header-bar-content .menu-content {
    padding-left: 0px;
  }
}
.header-bar .header-bar-content .menu-content ul {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  border-radius: 5px;
}
.header-bar .header-bar-content .menu-content ul .menu-item {
  position: relative;
  margin: 0 10px;
}
.header-bar .header-bar-content .menu-content ul .menu-item a {
  display: block;
  height: 40px;
  padding-top: 0;
  padding-bottom: 2px;
  padding-left: 20px;
  padding-right: 20px;
  text-decoration: none;
  text-align: center;
  align-content: center;
  color: #ceecff;
  font-family: "Marsh Serif", serif;
  font-weight: normal;
}
.header-bar .header-bar-content .menu-content ul .menu-item a:hover {
  color: #fff;
  cursor: pointer;
}
.header-bar .header-bar-content .menu-content ul .menu-item .sub-menu {
  position: absolute;
  display: none;
  list-style: none;
  margin: 0px;
  margin-left: 10px;
  padding: 0;
  top: 100%;
  left: 0;
  background-color: #f5f5f5;
  box-shadow: -4px 4px 8px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1);
}
.header-bar .header-bar-content .menu-content ul .menu-item .sub-menu li {
  position: relative;
}
.header-bar .header-bar-content .menu-content ul .menu-item .sub-menu li:hover .nested-sub-menu {
  display: block;
}
.header-bar .header-bar-content .menu-content ul .menu-item .sub-menu li a {
  width: 190px;
  padding-left: 20px;
  padding-right: 0;
  text-align: left;
  color: #000;
  font-family: "Noto Sans", sans-serif;
  margin: 4px;
}
.header-bar .header-bar-content .menu-content ul .menu-item .sub-menu li a:hover {
  color: #275bec;
  background-color: #e0e0e0;
  border-bottom-style: none;
  border-radius: 5px;
}
.header-bar .header-bar-content .menu-content ul .menu-item .sub-menu li .nested-sub-menu {
  display: none;
  position: absolute;
  top: 0;
  left: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: #f5f5f5;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1);
}
.header-bar .header-bar-content .menu-content ul .menu-item .sub-menu li .nested-sub-menu a {
  width: 200px;
  font-family: "Noto Sans", sans-serif;
}
.header-bar .header-bar-content .menu-content ul .menu-item .sub-menu li .nested-sub-menu .nested-sub-menu-item:hover {
  background-color: #e0e0e0;
}
.header-bar .header-bar-content .menu-content ul .menu-item:hover .sub-menu {
  display: block;
}
.header-bar .header-bar-content .search-content {
  display: flex;
  align-items: center;
}
.header-bar .header-bar-content .search-content input {
  height: 35px;
  width: 250px;
  border: 1px solid #fff;
  border-radius: 15px 0px 0px 15px;
  outline: none;
  font-size: 14px;
  color: #333;
  flex: 1;
  padding-left: 20px;
  padding-right: 20px;
}
.header-bar .header-bar-content .search-content button {
  height: 39px;
  width: 40px;
  background-color: #1b638b;
  border: 1px solid #1b638b;
  border-left: none;
  border-radius: 0px 15px 15px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  padding-left: 30px;
  padding-right: 30px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}
.header-bar .header-bar-content .search-content button i {
  color: white;
  font-size: 16px;
}
.header-bar .header-bar-content .search-content button:hover {
  background-color: #0e4d6e;
  border: 1px solid #0e4d6e;
  border-left: none;
}
.standalone-menu-item {
  position: relative;
  display: block;
  height: 40px;
  margin: 0;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 2px;
  font-family: "Marsh Serif", serif;
  text-decoration: none;
  text-align: center;
  align-content: center;
  color: #fff;
}
@media (max-width: 2560px) {
  .standalone-menu-item {
    padding-left: 20px;
    padding-right: 20px;
  }
}
@media (max-width: 1920px) {
  .standalone-menu-item {
    padding-left: 10px;
    padding-right: 10px;
  }
}
@media (max-width: 1280px) {
  .standalone-menu-item {
    padding-left: 5px;
    padding-right: 5px;
  }
}
@media (max-width: 1080px) {
  .standalone-menu-item {
    padding-left: 5px;
    padding-right: 5px;
  }
}
.standalone-menu-item:hover {
  color: #82baff;
  font-weight: bold;
  cursor: pointer;
}
.tenant-panel {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: 350px;
  padding: 10px;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.dialog-box {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 300px;
}
/*# sourceMappingURL=site-header.component-ZQVJKRGD.css.map */
